import Badge from '@rsos/components/capstone/Queue/Badge';
import { useUnreadConversationCount } from '../../../contexts/ConversationsContext';

/**
 * Notification count badge rendered on the Agency Chat tab. Shows the number
 * of interagency conversations with at least one unread message for the
 * current user. Hidden when there are no unread conversations.
 */
export default function AgencyChatBadge() {
  const count = useUnreadConversationCount('interagency');
  if (count <= 0) return null;
  return (
    <span data-name="agency-chat-tab-badge">
      <Badge counter={count} />
    </span>
  );
}
